export default __webpack_public_path__ + "static/media/arrow-left.886acd1d.svg";